/* eslint-disable react/no-unused-prop-types */
import { shape, string } from 'prop-types';
import { t } from '@lingui/macro';
import { omit } from 'lodash';

import Filter from '../../page-framework/filter/FilterDecorator';
import { filterPropTypes } from '../../page-framework/filter/FilterPropTypes';
import EntityListFilter, { useEntity, useEntityName } from '../entity-list-filter/EntityListFilter';
import getEntityListFilterStateServiceFactory from '../entity-list-filter/EntityListFilterStateService';
import { COLUMN_TYPES } from '../../data-table/DataTableColumns';
import { MaterialUiIcon } from '../../icon';
import { ENTITY_TYPES } from '../../../services/EntityService';

export const filterId = 'TestType';
export const filterTitle = t`Service Test Type`;
export const entityType = ENTITY_TYPES.TEST_TYPE;

export function useTestType() {
    return useEntity(filterId);
}

export function useTestTypeName() {
    return useEntityName(filterId);
}

const columns = [
    {
        type: COLUMN_TYPES.ICON,
        title: 'Type',
        width: 65,
        icons: [
            {
                getIcon: (row) => <MaterialUiIcon icon={row?.details?.icon} />,
            },
        ],
    },
    {
        title: 'Name',
        mapping: 'details.title',
        flex: 1,
        minWidth: 250,
        sortable: true,
    },
];

function TestTypeFilter(props) {
    const { state, filterActions } = props;
    const options = { entityType, columns };
    return <EntityListFilter options={options} state={state} filterActions={filterActions} />;
}

TestTypeFilter.propTypes = {
    id: filterPropTypes.id,
    title: filterPropTypes.title,
    filterActions: filterPropTypes.filterActions,
    state: shape({
        uuid: string.isRequired,
        name: string.isRequired,
    }),
};

TestTypeFilter.defaultProps = {
    // This filter does not link to an entity detail page, so we need to omit the options from the default props
    // to prevent the panel from attempting to create a link.
    ...omit(EntityListFilter.defaultProps, 'options'),
    id: filterId,
    title: filterTitle,
    state: undefined,
};

export default Filter({
    filterId,
    filterStateServiceFactory: getEntityListFilterStateServiceFactory(filterTitle, entityType, 'details.title'),
})(TestTypeFilter);
